import { Clock2, Info } from "@assets";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { BodySmall } from "@components/Typography";
import { UserStatus } from "@ctypes";
import { useUser } from "@hooks";
import { i18n, Translations } from "@i18n";

import { useStyles } from "./styles";
import { VerificationBannerProps } from "./types";

export const AccountStatusBanner = () => {
  const { user, loading } = useUser();

  const status = user?.status;

  if (loading || !status) {
    return null;
  }

  if ([UserStatus.VerificationInProgress, UserStatus.Pending, UserStatus.New].includes(status)) {
    return (
      <>
        <VerificationBanner
          variant="inProgress"
          title={i18n.t(Translations.ContributionVerificationInProgressBannerTitle)}
          subtitle={i18n.t(Translations.ContributionVerificationInProgressBannerSubtitle)}
        />
        <Spacing size={SpacingSizes.M} />
      </>
    );
  }

  if (status === UserStatus.VerificationFailed) {
    return (
      <>
        <VerificationBanner
          variant="error"
          title={i18n.t(Translations.ContributionVerificationErrorBannerTitle)}
          subtitle={i18n.t(Translations.ContributionVerificationErrorBannerSubtitle)}
        />
        <Spacing size={SpacingSizes.M} />
      </>
    );
  }

  return null;
};

const VerificationBanner = ({ variant, title, subtitle }: VerificationBannerProps) => {
  const styles = useStyles(variant);

  const icon = variant === "inProgress" ? <Clock2 /> : <Info size={24} />;

  return (
    <div style={styles.container}>
      <div style={styles.icon}>{icon}</div>
      <div style={styles.content}>
        <BodySmall style={styles.title}>{title}</BodySmall>
        <BodySmall>{subtitle}</BodySmall>
      </div>
    </div>
  );
};
